import AccountStore from './AccountStore';
import ApiStore from './ApiStore';
import AuthStore from './AuthStore';
import BikeStore from './BikeStore';
import CouponStore from './CouponStore';
import FileStore from './FileStore';
import LocationStore from './LocationStore';
import ModalStore from './ModalStore';
import OptionStore from './OptionStore';
import RegionProvinceStore from './RegionProvinceStore';
import CapacitieStore from './CapacitieStore';
import PriceStore from './PriceStore';
import UIStore from './UIStore';
import UserStore from './UserStore';
import SystemSettingStore from './SystemSettingStore';
import BikesLocationStore from './BikesLocationStore';
import NewsStore from './NewsStore';
import ApproveStore from './ApproveStore';
import LocationBikeStore from './LocationBikeStore';
import GeneralStore from './GeneralStore';
import InquiryStore from './InquiryStore';
import ContentSettingStore from './ContentSettingStore';
import BookingStore from './BookingStore';
import { action, makeObservable } from 'mobx';
import ReservationStore from './ReservationStore';
import DashboardStore from './DashboardStore';
import RevenueStore from './RevenueStore';
import BikeReturnStore from './BikeReturnStore';
import CommissionStore from './CommissionStore';
import CommissionMonthStore from './CommissionMonthStore';
import LocationEnduserStore from './LocationEnduserStore';

export default class RootStore {
    modalStore: ModalStore;
    apiStore: ApiStore;
    uiStore: UIStore;
    generalStore: GeneralStore;
    authStore: AuthStore;
    userStore: UserStore;
    accountStore: AccountStore;
    locationStore: LocationStore;
    optionStore: OptionStore;
    couponStore: CouponStore;
    bikeStore: BikeStore;
    regionProvinceStore: RegionProvinceStore;
    fileStore: FileStore;
    priceStore: PriceStore;
    capacitieStore: CapacitieStore;
    systemSettingStore: SystemSettingStore;
    bikesLocationStore: BikesLocationStore;
    newsStore: NewsStore;
    approveStore: ApproveStore;
    inquiryStore: InquiryStore;
    contentSettingStore: ContentSettingStore;
    locationBikeStore: LocationBikeStore;
    bookingStore: BookingStore;
    bikeReturnStore: BikeReturnStore;
    reservationStore: ReservationStore;
    dashboardStore: DashboardStore;
    revenueStore: RevenueStore;
    commissionStore: CommissionStore;
    commissionMonthStore: CommissionMonthStore;
    locationEnduserStore: LocationEnduserStore;

    constructor() {
        makeObservable(this, {
            clearAllStore: action.bound
        });
        this.modalStore = new ModalStore();
        this.apiStore = new ApiStore(this);
        this.uiStore = new UIStore(this);
        this.generalStore = new GeneralStore(this);
        this.authStore = new AuthStore(this);
        this.userStore = new UserStore(this);
        this.accountStore = new AccountStore(this);
        this.locationStore = new LocationStore(this);
        this.optionStore = new OptionStore(this);
        this.couponStore = new CouponStore(this);
        this.bikeStore = new BikeStore(this);
        this.regionProvinceStore = new RegionProvinceStore(this);
        this.fileStore = new FileStore(this);
        this.priceStore = new PriceStore(this);
        this.capacitieStore = new CapacitieStore(this);
        this.systemSettingStore = new SystemSettingStore(this);
        this.bikesLocationStore = new BikesLocationStore(this);
        this.newsStore = new NewsStore(this);
        this.approveStore = new ApproveStore(this);
        this.inquiryStore = new InquiryStore(this);
        this.contentSettingStore = new ContentSettingStore(this);
        this.locationBikeStore = new LocationBikeStore(this);
        this.bookingStore = new BookingStore(this);
        this.bikeReturnStore = new BikeReturnStore(this);
        this.reservationStore = new ReservationStore(this);
        this.dashboardStore = new DashboardStore(this);
        this.revenueStore = new RevenueStore(this);
        this.commissionStore = new CommissionStore(this);
        this.commissionMonthStore = new CommissionMonthStore(this);
        this.locationEnduserStore = new LocationEnduserStore(this);
    }

    clearAllStore() {
        this.accountStore.clean();
        this.locationStore.clean();
        this.bikeStore.clean();
        this.optionStore.clean();
        this.priceStore.clean();
        this.approveStore.clean();
        this.reservationStore.clean();
        this.newsStore.clean();
        this.revenueStore.clean();
        this.commissionStore.clean();
        this.commissionMonthStore.clean();
    }
}
